import LoginForm from "../components/authentication/LoginForm";
import DefaultLayout from "../components/layout/DefaultLayout";
import { Nav } from "react-bootstrap";
import { Link } from "react-router-dom";
import { AppRoutes } from "../routes";
function LoginPage() {
  const body = () => (
    <>
      <LoginForm></LoginForm>
      <Nav.Link as={Link} to={AppRoutes.FORGOT_PASSWORD}>
        Restablecer contraseña
      </Nav.Link>
      <Nav.Link as={Link} to={AppRoutes.VALIDATE_LESSEE}>
        Registrarse
      </Nav.Link>
      <Nav.Link as={Link} to="https://oficina.arrendamientoslacasona.com/login">
        Acceso de asesores
      </Nav.Link>
    </>
  );
  return (
    <div>
      <div>
        <DefaultLayout body={body()} />
      </div>
    </div>
  );
}

export default LoginPage;
